import React from 'react';
import { withTranslation } from 'react-i18next';
import {connect} from 'react-redux';
// material ui
import { ThemeProvider, StyledEngineProvider, createTheme, adaptV4Theme } from '@mui/material/styles';
import withStyles from '@mui/styles/withStyles';
import { IconButton, Dialog,DialogActions,DialogContent,DialogTitle, Table, TableBody, TableCell, TableHead, TableRow } from "@mui/material";
import { IndeterminateCheckBoxOutlined, MonetizationOnOutlined } from '@mui/icons-material'
// components
import '../../assets/stylesheet/addcompany.css';

const StyledTableCell = withStyles({
    head: {
      backgroundColor: '#000',
      color: '#fff',
    },
    body: {
      fontSize: 14,
      fontFamily: "'Poppins', sans-serif",
      textTransform:'capitalize'
    },
})(TableCell);

const StyledTableRow = withStyles((theme) => ({
root: {
    '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover,
    },
},
}))(TableRow);

const TitleTheme = createTheme(adaptV4Theme({
    typography: {
      body1: {
          fontFamily:'inherit !important'
      },
      h6:{
          fontFamily:'inherit',
          lineHeight:3.6,
          textAlign:'center',
          fontWeight:'bold',
          color:'#0F467A'
      }
    },
}))

const styles = theme => ({
    checkoutBtn:{
        height:'40px',
        padding:'0px 10px',
        display:'flex',
        flexDirection:'row',
        alignItems:'center',
        flexWrap:'nowrap',
        backgroundColor:'#0F467A',
        border:'1px solid #707070',
        fontWeight:'bold',
        borderRadius:'5px',
        textAlign:'center',
        color:'#fff',
        fontSize:'13px',
        lineHeight:3,
        cursor:'pointer',
    },

    label:{
        color:'#0F467A',
        fontSize:'16px',
        alignSelf:'flex-start'
    },

    backdrop: {
        zIndex: 111125,
        color: '#fff',
    },

    descInput:{
        alignSelf:'center',
        justifyContent: 'start',
        outline: 'none',
        border: 'none',
        backgroundColor: '#F4F6F8',
        width: '100%',
        margin: '10px 0px',
        paddingLeft: '10px',
        fontSize: '14px',
        borderRadius: '8px',
        resize: 'none',
        height:'120px',
        [theme.breakpoints.between('xs','md')]:{
            height:'50px'
        },
    },

    actionRoot:{
        padding:'8px 24px'
    },

    cancelBtn:{
        color:'rgba(0, 0, 0, 0.87)',
        border:'1px solid #E9E9E9',
        backgroundColor:'#F4F6F8'
    },

    mainDiv:{
        display:'flex',
        flexDirection:'column',
        padding:'10px 0px',
        height:'280px'
    },

    paper: {
        height: 300,
        width: '100%',
        overflowX: 'auto',
    },

    td:{
        color: '#0F467A',
    },

    scrollClass:{
        '&::-webkit-scrollbar': {
            width: '3px!important',
            height: '3px!important'
        },
        '&::-webkit-scrollbar-track': {
            backgroundColor:'hsla(0,0%,100%,.1)',
        },
        '&::-webkit-scrollbar-thumb': {
            backgroundColor: 'rgba(0,0,0,.1)',
        }
    },
})

class CheckoutDialog extends React.Component {
    _isMounted = false;

    componentWillUnmount() {
        this._isMounted = false;
    }

    handleClose = () => {
        this.props.onClose();
    }

    onChangeHandle = (agree) => {
        const { onChange, onClose } = this.props;
        onChange(agree);
        onClose();
    }

    checkout = () => {
        const { checkTermCondition, onClose } = this.props;
        checkTermCondition();
        onClose();
    }

    deleteReservation = index => {
        this.props.removeReservation(index);
    }
    
    render() {
        let { classes,t, i18n, termArray,checkoutReservation, companyName, checkTermCondition, removeReservation, dispatch,tReady, ...other } = this.props;
        const isRTL = i18n.translator.language;
        const ar = "'Cairo', sans-serif";
        const en = "'Poppins', sans-serif";
        const fontFamily = isRTL === 'ar' ? ar : en;
    return (
        (<React.Fragment>
            <Dialog
              {...other}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
              dir={isRTL === 'ar' ? 'rtl' : 'ltr'}
              style={{fontFamily}}
              fullWidth={true}
              maxWidth='sm'
            >
                <StyledEngineProvider injectFirst>
                    <ThemeProvider theme={TitleTheme}>
                            <DialogTitle id="alert-dialog-title" style={{fontFamily}}>{t('booking.checkout')}</DialogTitle>
                    </ThemeProvider>
                </StyledEngineProvider>
                <DialogContent style={{display:'flex',flexDirection:'column'}}>
                    <div className={classes.mainDiv}>
                        <div className={`${classes.paper} ${classes.scrollClass}`}>
                        <Table stickyHeader className={classes.table} aria-label="customized table">
                            <TableHead>
                            <TableRow>
                                <StyledTableCell>{t('reservations.name')}</StyledTableCell>
                                <StyledTableCell>{t('booking.service')}</StyledTableCell>
                                <StyledTableCell>{t('booking.gp')}</StyledTableCell>
                                <StyledTableCell>{t('group-list.gp-price')}</StyledTableCell>
                                <StyledTableCell>{t('user-manage.Action')}</StyledTableCell>
                            </TableRow>
                            </TableHead>
                            <TableBody>
                            {checkoutReservation.length > 0 && React.Children.toArray(checkoutReservation.map((row,index) => (
                            <StyledTableRow>
                                <StyledTableCell className={classes.td}>
                                    <b>{row.kidName}</b>
                                </StyledTableCell>
                                <StyledTableCell className={classes.td}>{row.serviceName}</StyledTableCell>
                                <StyledTableCell className={classes.td}>{row.groupName}</StyledTableCell>
                                <StyledTableCell className={classes.td}>{row.groupPrice + ' ' + row.currency}</StyledTableCell>
                                <StyledTableCell className={classes.td}>
                                    <IconButton onClick={()=> this.deleteReservation(index)} size="large">
                                        <IndeterminateCheckBoxOutlined style={{color:'#0F467A'}}/>
                                    </IconButton>
                                </StyledTableCell>
                            </StyledTableRow>
                            )))}
                            </TableBody>
                        </Table>
                        </div>
                    </div>
                </DialogContent>
                <DialogActions classes={{root:classes.actionRoot}}>
                    <div className={classes.checkoutBtn} style={{fontFamily}} onClick={this.checkout}>
                        <MonetizationOnOutlined style={{padding:'0px 10px'}}/>
                        <span style={{textTransform:'capitalize',}}>{t('booking.checkout')}</span>
                    </div>
                </DialogActions>
            </Dialog>
        </React.Fragment>)
    );
    }
}

const mapStateToProps = state => {
    return{
        user : state.user,
        company: state.company,
        lang: state.lang
    }
}

export default connect(mapStateToProps,null)(withStyles(styles)(withTranslation('common')(CheckoutDialog)));